export default "__VITE_ASSET__DYOwkrNK__"